import t from "../../../utils/translate";

import { ADDRESS_LINE_1, ADDRESS_LINE_2, CITY, ZIPCODE } from "../constants";

const rules = window.ww.validations;

const isValidRegex = (value, regex) => {
  const pattern = new RegExp(regex);

  return pattern.test(value);
};

const fieldData = {
  [ADDRESS_LINE_1]: {
    name: ADDRESS_LINE_1,
    id: ADDRESS_LINE_1,
    placeholder: t("JS_ADDRESS_LINE_ONE"),
    rules: {
      errorMessages: {
        isRequired: t("FIELD_ERROR_REQUIRED"),
        isMoreThanMax: t("JS_ADDRESS_LINE_ONE_ERROR_TOO_LONG"),
        isInvalidPattern: t("JS_ADDRESS_LINE_ONE_ERROR_INVALID")
      },
      validators: {
        isRequired: value => String(value).length === 0,
        isMoreThanMax: value => rules.addressLine1.max < String(value).length,
        isInvalidPattern: value =>
          !isValidRegex(value, rules.addressLine1.regex)
      }
    }
  },
  [ADDRESS_LINE_2]: {
    name: ADDRESS_LINE_2,
    id: ADDRESS_LINE_2,
    placeholder: t("JS_ADDRESS_LINE_TWO"),
    rules: {
      errorMessages: {
        isRequired: t("FIELD_ERROR_REQUIRED"),
        isMoreThanMax: t("JS_ADDRESS_LINE_TWO_ERROR_TOO_LONG"),
        isInvalidPattern: t("JS_ADDRESS_LINE_TWO_ERROR_INVALID")
      },
      validators: {
        isMoreThanMax: value => rules.addressLine2.max < String(value).length,
        isInvalidPattern: value =>
          !isValidRegex(value, rules.addressLine2.regex)
      }
    }
  },
  [CITY]: {
    name: CITY,
    id: CITY,
    placeholder: t("JS_CITY"),
    rules: {
      errorMessages: {
        isRequired: t("FIELD_ERROR_REQUIRED"),
        isMoreThanMax: t("JS_CITY_ERROR_TOO_LONG"),
        isInvalidPattern: t("JS_CITY_ERROR_INVALID")
      },
      validators: {
        isRequired: value => String(value).length === 0,
        isMoreThanMax: value => rules.city.max < String(value).length,
        isInvalidPattern: value => !isValidRegex(value, rules.city.regex)
      }
    }
  },
  [ZIPCODE]: {
    name: ZIPCODE,
    id: ZIPCODE,
    placeholder: t("JS_ZIPE_CODE"),
    rules: {
      errorMessages: {
        isRequired: t("FIELD_ERROR_REQUIRED"),
        isMoreThanMax: t("JS_ZIP_CODE_ERROR_TOO_LONG"),
        isInvalidPattern: t("JS_ZIP_CODE_ERROR_INVALID")
      },
      validators: {
        isRequired: value => String(value).length === 0,
        isMoreThanMax: value => rules.postalCode.max < String(value).length,
        isInvalidPattern: value => !isValidRegex(value, rules.postalCode.regex)
      }
    },
    inputMode: "numeric",
    regexReplace: /\D/g
  }
};

export default fieldData;
